<template>
    <div>
        <header id="header">
            <div class="menu">
                <div class="logo">
                    AH
                </div>
                <ul>
                    <li><a href="">APP</a></li>
                    <li><a href="">STORIES</a></li>
                </ul>
            </div>
            <div class="onglets">
                <div class="onglet" style="border-color:#FFBF60;">
                    <div class="icon"><i class="fal fa-images"></i></div>
                    <div class="text">
                        Interactive Image : Cazèreaubord dulac
                    </div>
                    <div class="close"><i class="fal fa-times"></i></div>
                </div>
                <div class="onglet active unsave">
                    <div class="icon"><i class="fal fa-images"></i></div>
                    <div class="text">
                        * Interactive Image : Cazère au bord du lac
                    </div>
                    <div class="close"><i class="fal fa-times"></i></div>
                </div>
                <div class="onglet unsave">
                    <div class="icon"><i class="fal fa-images"></i></div>
                    <div class="text">
                        * Interactive Image : Cazère au bord du lac
                    </div>
                    <div class="close"><i class="fal fa-times"></i></div>
                </div>
                <div class="onglet unsave">
                    <div class="icon"><i class="fal fa-images"></i></div>
                    <div class="text">
                        * Interactive Image : Cazère au bord du lac
                    </div>
                    <div class="close"><i class="fal fa-times"></i></div>
                </div>
                <div class="onglet unsave">
                    <div class="icon"><i class="fal fa-images"></i></div>
                    <div class="text">
                        * Interactive Image : Cazère au bord du lac
                    </div>
                    <div class="close"><i class="fal fa-times"></i></div>
                </div>
                <div class="onglet unsave">
                    <div class="icon"><i class="fal fa-images"></i></div>
                    <div class="text">
                        * Interactive Image : Cazère au bord du lac
                    </div>
                    <div class="close"><i class="fal fa-times"></i></div>
                </div>
                <div class="onglet unsave">
                    <div class="icon"><i class="fal fa-images"></i></div>
                    <div class="text">
                        * Interactive Image : Cazère au bord du lac
                    </div>
                    <div class="close"><i class="fal fa-times"></i></div>
                </div>
                <div class="onglet unsave">
                    <div class="icon"><i class="fal fa-images"></i></div>
                    <div class="text">
                        * Interactive Image : Cazère au bord du lac
                    </div>
                    <div class="close"><i class="fal fa-times"></i></div>
                </div>
                <div class="onglet unsave">
                    <div class="icon"><i class="fal fa-images"></i></div>
                    <div class="text">
                        * Interactive Image : Cazère au bord du lac
                    </div>
                    <div class="close"><i class="fal fa-times"></i></div>
                </div>
            </div>
            <div class="user">
                <div class="options">
                    <div class="btn square item">
                        <i class="fal fa-expand-arrows"></i>
                    </div>
                    <div class="btn square item">
                        <i class="fal fa-cog"></i>
                    </div>
                </div>
                <div class="left">
                    <div class="name">
                        Lucas ISNARDON
                    </div>
                    <div class="status">
                        <div class="status-ico"></div>
                        Online
                    </div>
                </div>
                <div class="photo">
                    <img src="../../assets/images/portrait/small/avatar-s-1.jpg"/>
                </div>
            </div>
        </header>
        <section id="content">
            <div class="row full-h">
                <div class="column-center">
                    <div class="header">
                        <div class="col-4 p-1 flex align-center">
                            <div class="title-h1 p-2 mr-2 text-center">
                                <i class="fal fa-images"></i>
                            </div>
                            <div>
                                <div class="title-h1 self-editable">
                                    Cazères au fil du temps
                                    <i class="fal fa-pen"></i>
                                </div>
                                <div class="title-h2">Interactive Image</div>
                            </div>
                        </div>
                        <div class="col-4 p-1 text-center">
                            <div class="title-h2">
                                Last modified: 2021-02-22 15:43:20
                            </div>
                        </div>
                        <div class="col-4 p-1 flex align-center justify-end">
                            <div class="btn link active">Cancel</div>
                            <div class="btn icon">
                                <i class="fal fa-save"></i> Save
                            </div>
                            <div class="hr-v"></div>
                            <div class="btn square"><i class="fal fa-undo"></i></div>
                            <div class="btn square disabled"><i class="fal fa-redo"></i></div>
                            <div class="hr-v"></div>
                            <div class="btn square active">1</div>
                            <div class="btn square">2</div>
                            <div class="btn square">3</div>
                            <div class="btn square"><i class="fal fa-plus"></i></div>
                        </div>
                    </div>
                    <div class="content-image">
                        <div class="editable-image">
                            <img src="../../assets/images/test3.jpg"/>
                        </div>
                    </div>
                </div>
                <div class="column-right">
                    <div class="volets">
                        <div class="volet active">
                            <div class="text">Labels</div>
                        </div>
                        <div class="volet">
                            <div class="text">Introduction</div>
                        </div>
                        <div class="volet">
                            <div class="text">Images</div>
                        </div>
                        <div class="volet">
                            <div class="text">Chapters</div>
                        </div>
                        <div class="volet">
                            <div class="text">Other</div>
                        </div>
                    </div>
                    <div class="row align-center">
                        <div class="col-6">
                            <div class="form-input">
                                <div class="input">
                                    <input type="text" placeholder="Search">
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-input-list">
                                <div class="input">
                                    <input name="browser" placeholder="Filters"
                                           @focus="$refs.list2.style.display = 'block'"
                                           @blur="$refs.list2.style.display = 'none'">
                                    <div class="after">
                                        <i class="fa fa-angle-down"></i>
                                    </div>
                                </div>
                                <ul class="list" ref="list2" style="display: none;">
                                    <li>Chrome</li>
                                    <li class="select">Safari</li>
                                    <li>Internet Explorer</li>
                                    <li>FireFox</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col p-1">
                            <div class="btn icon">
                                <i class="fal fa-plus"></i> Add label
                            </div>
                        </div>
                    </div>
                    <div class="hr mt-1"></div>
                    <div class="row wrap">
                        <ul class="label-items">
                            <li class="label-item">
                                <div class="left">
                                    <div class="image">
                                        <i class="fal fa-image"></i>
                                    </div>
                                    <div class="link">
                                        <div class="text no-link">Not Linked</div>
                                    </div>
                                </div>
                                <div class="buttons">
                                    <div class="btn square item">
                                        <i class="fal fa-link"></i>
                                    </div>
                                    <div class="btn square item">
                                        <i class="fal fa-trash"></i>
                                    </div>
                                    <div class="btn square item">
                                        <i class="fal fa-edit"></i>
                                    </div>
                                </div>
                            </li>
                            <li class="label-item active">
                                <div class="left">
                                    <div class="image">
                                        <i class="fal fa-map-marker"></i>
                                    </div>
                                    <div class="link">
                                        <div class="text linked">
                                            La petite Barrade
                                            <i class="fa fa-images"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="buttons">
                                    <div class="btn square item">
                                        <i class="fal fa-link"></i>
                                    </div>
                                    <div class="btn square item">
                                        <i class="fal fa-trash"></i>
                                    </div>
                                    <div class="btn square item">
                                        <i class="fal fa-edit"></i>
                                    </div>
                                </div>
                            </li>
                            <li class="label-item">
                                <div class="left">
                                    <div class="image">
                                        <img src="../../assets/images/test.jpg" alt="">
                                    </div>
                                    <div class="link">
                                        <div class="text linked">
                                            La sortie nord
                                            <i class="fa fa-text"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="buttons">
                                    <div class="btn square item">
                                        <i class="fal fa-link"></i>
                                    </div>
                                    <div class="btn square item">
                                        <i class="fal fa-trash"></i>
                                    </div>
                                    <div class="btn square item">
                                        <i class="fal fa-edit"></i>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="box">
                        <div class="header">
                            <div class="type">
                                <i class="fal fa-image"></i>
                            </div>
                            <div class="titles">
                                <div class="link no-link">Not linked</div>
                                <div class="type">Overlay</div>
                            </div>
                            <div class="buttons">
                                <div class="btn link active">
                                    Cancel
                                </div>
                                <div class="btn square item">
                                    <i class="fal fa-times"></i>
                                </div>
                            </div>
                        </div>
                        <div class="content">
                            <div class="form-input">
                                <label for="">Label</label>
                                <div class="input">
                                    <input type="text" value="Valeur">
                                    <div class="after">px</div>
                                </div>
                            </div>
                            <div class="form-input">
                                <label for="">Label</label>
                                <div class="input">
                                    <input type="text" placeholder="Placeholder">
                                </div>
                            </div>
                            <div class="form-image">
                                <label for="">Image</label>
                                <div class="input">
                                    <input type="file" style="display:none;" ref="file">
                                    <div class="image">
                                        <img src="../../assets/images/test.jpg" height="2060" width="2053"/>
                                    </div>
                                    <div class="upload">
                                        <div class="content">
                                            <div class="title-h2">Upload... (20%)</div>
                                            <div class="bar" ref="upload-bar"></div>
                                        </div>
                                    </div>
                                    <div class="buttons">
                                        <div class="btn square link light">
                                            <i class="fal fa-trash"></i>
                                        </div>
                                        <div class="btn square">
                                            <i class="fal fa-edit"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "TestPage"
}
</script>
